import React, { useMemo, useState } from "react";
import { styled } from "styled-components";
import { Portal } from "../Portal";
import Toast from "./Toast";
import { rem, idGenerator } from "../../utils";
export const ToastContext = React.createContext({
    defaults: {
        defaultShowCloseBtn: true,
        defaultTimeout: 3000,
        defaultActionBtnName: "Show",
        defaultPauseAutoHideOnHover: true,
    },
    toasts: [],
    dispatchToast: () => { },
    clearToast: () => { },
});
const ToastPlacement = styled.div `
  position: fixed;
  bottom: ${rem(8)};
  left: ${rem(8)};
  right: ${rem(8)};
  z-index: 999999999;
`;
export const ToastProvider = ({ children, defaultTimeout = 3000, defaultShowCloseBtn = true, defaultActionBtnName = "Show", defaultPauseAutoHideOnHover = true, }) => {
    const [toasts, setToasts] = useState([]);
    const api = useMemo(() => ({
        defaults: {
            defaultTimeout,
            defaultShowCloseBtn,
            defaultActionBtnName,
            defaultPauseAutoHideOnHover,
        },
        toasts,
        dispatchToast: (toast) => {
            setToasts([toast]);
        },
        clearToast: (toast) => {
            setToasts([...toasts.filter((t) => t !== toast)]);
        },
    }), [
        toasts,
        defaultTimeout,
        defaultShowCloseBtn,
        defaultActionBtnName,
        defaultPauseAutoHideOnHover,
    ]);
    return (React.createElement(ToastContext.Provider, { value: api },
        React.createElement(React.Fragment, null,
            children,
            React.createElement(Portal, null,
                React.createElement(ToastPlacement, null, toasts.map((toast) => (React.createElement(Toast, { "data-cy": "toast", key: toast.key || idGenerator("toast-"), toast: toast }))))))));
};
export default ToastProvider;
//# sourceMappingURL=ToastProvider.js.map